module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-6 17.002c0 .552-.452.998-1.004.998h-8.022l2.682 2.838a1.046 1.046 0 0 1 0 1.432l-1.368 1.434a.933.933 0 0 1-1.368 0l-6.642-6.96a1.053 1.053 0 0 1 0-1.434l6.7-7.014a.94.94 0 0 1 1.368 0l1.368 1.434a1.046 1.046 0 0 1 0 1.432L15.028 14h7.968c.552 0 1.004.45 1.004 1.002v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/left-square-4.js
// module id = 1227
// module chunks = 14